module.exports = __webpack_public_path__ + "img/DE00911.af94019c.png";